/** @jsx jsx */
import { jsx } from "@emotion/react";
import siteConfig from "../../../data/siteConfig";
import Share from "../Share";
import PropsFooter from "../../types/PropsFooter";

const Footer = (props: PropsFooter) => {
  const data = {
    slug: props.data?.slug ? `/${props.data?.slug}` : "/",
    title: props.data?.title
      ? `${props.data?.title} | ${siteConfig.title}`
      : siteConfig.title,
    color: props.data?.color ? props.data?.color : "black",
  };
  return (
    <footer css={{ paddingTop: "3.5rem", paddingBottom: "3rem" }}>
      <div
        css={{
          textAlign: "center",
          fontFamily: "'Zilla Slab', serif",
          fontSize: "1.2rem",
        }}
      >
        <p css={{ marginBottom: "1em" }}>
          <span css={{ display: "inline-block" }}>Did our work tap into</span>{" "}
          <span css={{ display: "inline-block" }}>
            something deep within your core?
          </span>
        </p>
        <p>
          <span css={{ display: "inline-block" }}>You can click below</span>{" "}
          <span css={{ display: "inline-block" }}>
            to <strong>share</strong> this with your root networks.
          </span>
        </p>
      </div>
      <Share data={data} />
    </footer>
  );
};

export default Footer;
